import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Quote } from "lucide-react";

export default function TestimonialMarquee({ heading = true }) {
  const { t } = useLanguage();
  const items = t.testimonials.items;
  const loop = [...items, ...items];

  return (
    <section className="py-24 overflow-hidden bg-brand-bg" data-testid="testimonial-marquee">
      <div className="container-pad">
        {heading && (
          <div className="max-w-2xl">
            <div className="overline">{t.testimonials.overline}</div>
            <h2 className="mt-3 text-4xl sm:text-5xl leading-[1.05]">
              {t.testimonials.title}
            </h2>
          </div>
        )}
      </div>

      <div className="relative mt-14">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-brand-bg to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-brand-bg to-transparent z-10" />

        <div className="marquee-track gap-6 pl-6">
          {loop.map((item, idx) => (
            <article
              key={`${item.name}-${idx}`}
              data-testid={`testimonial-${idx}`}
              className="min-w-[340px] max-w-[380px] shrink-0 rounded-xl bg-brand-surface border border-brand-line p-7"
            >
              <Quote className="text-brand-accent" size={22} />
              <p className="mt-4 text-[15px] leading-relaxed text-brand-text/80">
                {`"${item.text}"`}
              </p>
              <div className="mt-6 pt-5 border-t border-brand-line">
                <div className="font-serif text-lg text-brand-primary">{item.name}</div>
                <div className="text-xs uppercase tracking-widest text-brand-muteText mt-1">
                  {item.role}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
